
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import RichTextInputDialog from "@/components/Reusable/CustomInputs/RichTextInput/RichTextInputDialog.vue";
import RichTextInputTinyMceDialog from "@/components/Reusable/CustomInputs/RichTextInput/RichTextInputTinyMceDialog.vue";
import Icon from "@/components/UI/Icon.vue";
import {
  textAndRichTextVariableItem,
  textAndRichTextVariableOptions
} from "@/types/controls";
import { keyboardShortcuts } from "@/lib/keyboard-shortcuts/keyboard-shortcuts";
import { KEYBOARD_SHORTCUTS } from "@/lib/keyboard-shortcuts/global-shortcuts";
import { uiStore } from "@/store/store";

@Component({
  components: { Icon, RichTextInputDialog, RichTextInputTinyMceDialog }
})
export default class RichTextInput extends Vue {
  get mode() {
    if (this.variableOptions || this.variableItems) {
      return "tiptap";
    }

    if (uiStore.settings.isTinyMcePreferredForRichText) {
      return "tinymce";
    }

    return "tiptap";
  }

  @Prop({ default: "" })
  value!: string;

  @Prop()
  variableOptions!: textAndRichTextVariableOptions;

  @Prop()
  variableItems!: textAndRichTextVariableItem[];

  dialog = false;

  mounted() {
    keyboardShortcuts.register(KEYBOARD_SHORTCUTS.CMD_E, this.openDialog);
  }

  beforeDestroy() {
    keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_E);
  }

  closeDialog() {
    this.dialog = false;
  }

  openDialog() {
    this.dialog = true;
  }

  get isEmpty() {
    return (
      this.value == undefined || this.value == "" || this.value == "<p></p>"
    );
  }

  updateValue(newValue: string | null) {
    this.$emit("input", newValue);
  }
}
